import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Credibility } from "@/components/landing/Credibility";
import { Problem } from "@/components/landing/Problem";
import { Pillars } from "@/components/landing/Pillars";
import { Steps } from "@/components/landing/Steps";
import { Outcomes } from "@/components/landing/Outcomes";
import { Program } from "@/components/landing/Program";
import { GameGallery } from "@/components/landing/GameGallery";
import { Toolkit } from "@/components/landing/Toolkit";
import { Audience } from "@/components/landing/Audience";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { About } from "@/components/landing/About";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { ThankYou } from "@/components/landing/ThankYou";

function App() {
  const isThankYou = window.location.pathname.replace(/\/+$/, "") === "/dziekuje";

  useEffect(() => {
    if (isThankYou) return;
    const lenis = new Lenis({ duration: 1.1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  if (isThankYou) {
    return (
      <div className="font-body min-h-screen">
        <ThankYou />
        <Toaster position="bottom-right" />
      </div>
    );
  }

  return (
    <div className="font-body min-h-screen overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Credibility />
        <Problem />
        <Pillars />
        <Steps />
        <Outcomes />
        <Program />
        <GameGallery />
        <Toolkit />
        <Audience />
        <Pricing />
        <Testimonials />
        <About />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
